<template>
  <base-dialog
    :action="onAction"
    :action-name="'Remove'"
    :close="onClose"
    :title="'Remove external account'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <div>
        <p>
          Are you sure you want to remove this external account?<br><br>
          This action is permanent, and the connected account will no longer be able to receive funds using this external account.
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  methods:{
    ...mapActions([ 'deleteExternalAccount' ]),
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      const payload = {
        id: this.id,
      }

      await this.deleteExternalAccount(payload)

      this.$emit('action', payload)
    }
  }
}
</script>
